var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showErrorInfo)?_c('div',{staticClass:"load-center-mask dis-f align-center justify-center"},[_c('span',{staticClass:"loading-text fs-14 c-white text-center paddingh40 paddingv15",domProps:{"innerHTML":_vm._s(_vm.info)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }